import DefaultValidation from "@/services/validations/DefaultValidation";
import * as Util from '@/functions/Util';

export default class MotivoValidation extends DefaultValidation{
    constructor(msgs) {
      super(msgs);
    }
    validate(model, refs) {
      let validated = true;
    
    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (Util.isNull(model.descricao)) {
      refs.descricaoInput.focusedOut = true;
      validated = false;
    }

    if (!model.icone) {
      refs.iconeInput.focusedOut = true;
      validated = false;
    }
    
    const isOrigemFlex = model.origem ? model.origem.id === "CONTA_CORRENTE_FLEX" : false;
    const isQtdeMinimaFotosValido = Util.isNull(model.qtdeminimafoto) || model.qtdeminimafoto < 0;

    if (isOrigemFlex && isQtdeMinimaFotosValido) {
      refs.qtdeMinimaFoto.focusedOut = true;
      validated = false;
    }

    if (Util.isNull(model.origem)) {
      refs.origemSelected.focusedOut = true;
      validated = false;
    }
    
    return validated;

  }
}